export { default as RestaurantNewDishes } from './RestaurantNewDishes'
export { default as RestaurantNewDishesSkeleton } from './Skeleton'
